import api from './config';

// Menús
export const getMenus = (filters = {}) =>
  api.get('/cafeteria/menus', { params: filters }).then(r => r.data);

export const getMenuToday = () =>
  api.get('/cafeteria/menus/today').then(r => r.data);

export const getMenusWeek = (lunes) =>
  api.get('/cafeteria/menus/week', { params: { lunes } }).then(r => r.data);

export const getMenu = (id) =>
  api.get(`/cafeteria/menus/${id}`).then(r => r.data);

export const createMenu = (data) =>
  api.post('/cafeteria/menus', data).then(r => r.data);

export const updateMenu = (id, data) =>
  api.put(`/cafeteria/menus/${id}`, data).then(r => r.data);

export const publishMenu = (id) =>
  api.post(`/cafeteria/menus/${id}/publish`).then(r => r.data);

export const closeMenu = (id) =>
  api.post(`/cafeteria/menus/${id}/close`).then(r => r.data);

export const deleteMenu = (id) =>
  api.delete(`/cafeteria/menus/${id}`).then(r => r.data);

// Opciones
export const addOpcion = (menuId, data) =>
  api.post(`/cafeteria/menus/${menuId}/opciones`, data).then(r => r.data);

export const updateOpcion = (id, data) =>
  api.put(`/cafeteria/opciones/${id}`, data).then(r => r.data);

export const deleteOpcion = (id) =>
  api.delete(`/cafeteria/opciones/${id}`).then(r => r.data);

// Selecciones
export const seleccionar = (menu_id, opcion_id) =>
  api.post('/cafeteria/selecciones', { menu_id, opcion_id }).then(r => r.data);

export const getMisSelecciones = () =>
  api.get('/cafeteria/selecciones/me').then(r => r.data);

// Reporte
export const getReporte = (menuId) =>
  api.get(`/cafeteria/menus/${menuId}/reporte`).then(r => r.data);
